export const allowShowZeroInTable = (questionnaireCode: string) => {
	switch (questionnaireCode) {
		case 'Psychoonkologický screening MOÚ':
		case 'Bolest po nastavení analgetické terapie':
		case 'ECOG':
		case 'ESAS':
			return true;
	}
	return false;
};
